let track = document.querySelectorAll('.content');
let track_lenght = 0;
let txtEl = document.querySelectorAll('.txt-container');
let iconEl = document.querySelectorAll('.icon-container');

for (let i = 0; i < track.length / 2; i++) track_lenght += track[i].clientWidth;

if (track_lenght + 20 > document.documentElement.clientWidth) {

    if ((60 - (track_lenght - document.documentElement.clientWidth) / 8) < 10) {
        document.querySelector('.section--call-outs').classList.add('sliding');
        document.querySelector('.section--call-outs .track[aria-hidden="true"]').style.display = 'flex';
    }

    else if (document.documentElement.clientWidth > 1300){
        txtEl.forEach(el => el.style.marginRight = (60 - (track_lenght - document.documentElement.clientWidth) / 8) + 'px');
        txtEl[txtEl.length / 2 - 1].style.marginRight = '0';
        iconEl.forEach(el => el.style.marginRight = (60 - (track_lenght - document.documentElement.clientWidth) / 8) + 'px');
        iconEl[iconEl.length / 2 - 1].style.marginRight = '0';
    }

}

if (track_lenght < document.documentElement.clientWidth && document.documentElement.clientWidth < 1300) {
    marginTemp = (document.documentElement.clientWidth - track_lenght) / 10;
    txtEl.forEach(el => el.style.marginRight = marginTemp + 'px');
    iconEl.forEach(el => el.style.marginRight = marginTemp + 'px');
}